export default __webpack_public_path__ + "static/media/pr.0a59fea6.jpeg";